import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiUrls } from 'src/app/core/classes/ApiUrls';
import { GlobalConfiguration } from 'src/app/core/classes/GlobalConfiguration';
import { CustomValidators } from 'src/app/shared/classes/CustomValidators';
import { Helper } from 'src/app/shared/classes/Helper';
import { ModalInjectedData } from 'src/app/shared/classes/ModalInjectedData';
import { Widget } from 'src/app/shared/classes/Widget';
import { FilterType } from 'src/app/shared/enums/FilterType';
import { FormState } from 'src/app/shared/enums/FormState';
import { SupportedFormat } from 'src/app/shared/enums/SupportedFormat';
import { IFormGeneratorInput } from 'src/app/shared/interfaces/form-generator/IFormGeneratorInput';
import { MultiStepFormService } from 'src/app/shared/services/modal/multi-step-form/multi-step-form.service';
import { ButtonColorType } from './../../../../enums/ButtonColorType';
import { ButtonType } from './../../../../enums/ButtonType';
import { IButtonGeneratorInput } from './../../../../interfaces/button-generator/IButtonGeneratorInput';

@Component({
    selector: 'app-create-mg-report-step-one',
    templateUrl: './create-mg-report-step-one.component.html',
    styleUrls: ['./create-mg-report-step-one.component.sass']
})
export class CreateMgReportStepOneComponent implements OnInit {
    widgetRef: Widget = null;
    reportNameFormGenInput: IFormGeneratorInput = null;
    reportNameFormGroup: FormGroup;
    widgetsSelected: string[] = [];
    widgetsSelectedMap: Map<string, string> = new Map();
    noWidgetsSelected = false;
    SupportedFormat = SupportedFormat;
    GlobalConfiguration = GlobalConfiguration;
    edit = false;
    stepData = null;
    ApiUrls = ApiUrls;
    nextButton: IButtonGeneratorInput = {
        buttonName: 'Next',
        buttonColorType: ButtonColorType.PRIMARY,
        buttonType: ButtonType.FLAT,
        function: this.goToStepTwo.bind(this)
    };
    constructor(
        private modalInputData: ModalInjectedData,
        private multiStepFormService: MultiStepFormService
    ) {}

    ngOnInit(): void {
        this.widgetRef = this.modalInputData.data.widgetRef;
        if (
            this.modalInputData &&
            this.modalInputData.data &&
            this.modalInputData.data['edit']
        ) {
            this.edit = true;
            this.stepData = this.modalInputData.data['stepData'];
            this.widgetsSelected = this.stepData['widgetIds'];
        }
        let reportName = this.edit ? this.stepData['reportName'] : null;
        if (
            this.multiStepFormService.stepData &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .has(1)
        ) {
            const stepData = this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1);
            this.widgetsSelected = stepData['widgetsSelected'];
            this.widgetsSelectedMap = stepData['widgetsSelectedMap'];
            reportName = stepData['reportName'];
        }
        this.reportNameFormGenInput = {
            formName: 'ReportName',
            state: this.edit ? FormState.IDLE : FormState.CREATE,
            submitButton: null,
            fields: [
                {
                    name: 'reportName',
                    fieldType: FilterType.TEXT,
                    label: 'Report Name',
                    placeholder: 'Enter Report Name',
                    required: true,
                    value: reportName ? reportName : '',
                    disabled: this.edit,
                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Report name is required'
                        }
                    ]
                }
            ]
        };
    }

    goToStepTwo() {
        Helper.markAllFieldAsTouched(this.reportNameFormGroup);
        if (!this.reportNameFormGroup || this.reportNameFormGroup.invalid) {
            return;
        }
        if (!this.widgetsSelected || !this.widgetsSelected.length) {
            this.noWidgetsSelected = true;
            return;
        }

        this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .set(1, {
                reportName: this.reportNameFormGroup.get('reportName').value,
                widgetsSelected: this.widgetsSelected,
                widgetsSelectedMap: this.widgetsSelectedMap
            });
        this.multiStepFormService.nextStep(this.modalInputData.modalId);
    }
}
